import styled from "styled-components";
import { panelSpacing } from "../../../../../common/styles";

export const ProgramDetailsContainer = styled.div``;

export const Basics = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  @media (max-width: 767px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }
`;
export const LeftSection = styled.div`
  width: calc(100% - 150px - ${panelSpacing}px);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  @media (max-width: 767px) {
    margin-top: 30px;
    width: 100%;
  }
`;
export const RightSection = styled.div`
  width: 100%;
  background: #fff;
  padding-bottom: 18px;
  box-shadow: 0px 4px 50px 0px rgba(151, 140, 140, 0.2);
  border-radius: 10px;
  overflow: hidden;
  max-width: 250px;
`;

export const TooltipContainer = styled.div`
  position: relative;
`;
